import React, { useContext, useState } from 'react'
import CustomerContext from '../Context/CustomerContext';
import GridLogic from '../Grid/GridLogic'

function Everify(){
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
    const {
        cookies
    } = useContext(CustomerContext)
    const [defaultColDefs] = useState([
        {headerName:'Employee ID', field:'EmployeeID', cellClass:'linked-cell'},
        {headerName:'Assignment ID',field:'AssignmentID', cellClass:'linked-cell'},
        {headerName:'Everified',field:'Everified'},
        {headerName:'Case Eligibility',field:'CaseEligibilityStatement'},
        {headerName:'Case Status', field:'CaseStatus'},
        {headerName:'Days On Assignment',field:'DaysOnAssginment'},
        {headerName:'Hours on Assignment',field:'TotalHours'},
        {headerName:'Last Pay Date', field:'LastPayDate', valueFormatter: (date)=>{return TransformDate(date)}},
        {headerName:'First Name', field:'FirstName'},
        {headerName:'Last Name', field:'LastName'},
        {headerName:'Email',field:'EmployeeEmail', cellClass:'linked-cell'},
        {headerName:'Cell Phone', field:'EmployeeCellPhone', cellClass:'linked-cell'},
        {headerName:'Home Phone', field:'EmployeeHomePhone', cellClass:'linked-cell'},
        {headerName:'Customer',field:'CustName'},
        {headerName:'Department',field:'DeptName'},
        {headerName:'Branch',field:'BranchName'},
    ]);
    const [currentGrid] = useState('Everify');
    const [currentPage] = useState('Everify');
    const [apiUrl] = useState(`${REACT_APP_API_URL}/GetEmployeeEverifyByBranch?token=${cookies.get('customer').Token}`);
    const [customerColumnDefs] = useState([
        {headerName:'Employee ID', field:'EmployeeID', cellClass:'linked-cell'},
        {headerName:'Everified',field:'Everified'},
        {headerName:'First Name', field:'FirstName'},
        {headerName:'Last Name', field:'LastName'},
        {headerName:'Case Eligibility',field:'CaseEligibilityStatement'},
        {headerName:'Case Status', field:'CaseStatus'},
        {headerName:'Days on Assignment', field:'DaysOnAssginment'},
        {headerName:'Hours on Assignment',field:'TotalHours'},
        {headerName:'Customer',field:'CustName'},
        {headerName:'Department',field:'DeptName'},
        {headerName:'Branch',field:'BranchName'},
    ]);
    const [show] = useState(false);

    function TransformDate(date){
        if(date.value){
            return date.value.split('T')[0];
        }else{
            return 'None'
        }
    }

    function HandleClick(e){
        if(e.colDef.field==='EmployeeID'){
            openInNewTab('https://beyond.ontempworks.com/employee/'+e.data.EmployeeID)
        }else if(e.colDef.field==='AssignmentID'){
            openInNewTab('https://beyond.ontempworks.com/assignment/'+e.data.AssignmentID)
        }else if(e.colDef.field==='EmployeeCellPhone'){
            window.open('tel:'+e.data.EmployeeCellPhone)
        }else if(e.colDef.field==='EmployeeHomePhone'){
            window.open('tel:'+e.data.EmployeeHomePhone)
        }else if(e.colDef.field==='EmployeeEmail'){
            window.open('mailto:'+e.data.EmployeeEmail)
        }
    }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    function SortData(data){
        let filteredData = [];
        data.forEach(candidate=>{
            if(candidate.Everified==='NO'){
                filteredData.push(candidate)
            }
        })
        return filteredData
    }

    return(
        <GridLogic
            popupInfo={{
                show:show
            }}
            currentPage={currentPage}
            currentGrid={currentGrid}
            apiUrl={apiUrl}
            defaultColDefs={defaultColDefs}
            customerColumnDefs={customerColumnDefs}
            HandleClick={HandleClick}
            SortData={SortData}
            show={show}
        ></GridLogic>
    )
}

export default Everify;